class BankAccount {
  constructor (options) {
    this.options = options || {}
    this.modes = ['read', 'staging']
  }

  get name () {
    return `Bank (${this.options.accountType || 'unconfigured'})`
  }

  async fetch () {
    // Bank accounts are synced manually via the staged sheet, not auto-refreshed
    return ''
  }
}

export default BankAccount
